export default "__VITE_ASSET__BmRMTiTq__"